import styles from "./InflationCalculator.module.css";
const formatIndianNumber = (num) => {
  return Number(num).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
const ResultCard = ({results}) => { 
  return (
    <>
      {results && (
        <>
          <div className={styles.results}>
            <div className={styles.resultRow}>
              <span>Annual Expenditure:</span>
              <span>₹{" "}{formatIndianNumber(results.annualExpenditure)}</span>
            </div>

            <div className={styles.resultRow}>
              <span>Years to Retirement:</span>
              <span>{results.yearsToRetirement}</span>
            </div>

            <div className={styles.resultRow}>
              <span>Monthly Expenses @ Retirement (A):</span>
              <span>₹{" "}{formatIndianNumber(results.futureMonthlyExpense)}</span>
            </div>

            <p className={styles.caption}>
              Have YOU done YOUR Retirement Planning yet?
            </p>

            <div className={styles.resultRow}>
              <span>Yearly Expense @ Retirement (B) = A x 12:</span>
              <span>₹{" "}{formatIndianNumber(results.yearlyExpense)}</span>
            </div>

            <div className={styles.resultRow}>
              <span>Retirement Corpus Required (C) = B x 20:</span>
              <span>₹{" "}{formatIndianNumber(results.retirementCorpus)}</span>
            </div>

            <div className={styles.resultRow}>
              <span>Retirement Corpus Required in ₹ Crores:</span>
              <span>₹{" "}{formatIndianNumber(results.retirementCorpusCrores)}</span>
            </div>
          </div>
        </>
      )}

    </>
  );
};

export default ResultCard;